<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad">
                <div class="container-fluid">
                    <form id="FormRespuesta" role="form" method="post" autocomplete="off" onSubmit="return false">
                        <div class="form-group row">

                            <div class="col-12 col-sm-12 col-md-7 col-lg-7">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <label>Folio</label>
                                        <input v-model="objCancel.UUID" id="Folio" name="Folio" type="text" class="form-control" readonly>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <label>Factura</label>
                                        <input v-model="objCancel.FolioFactura" id="Factura" name="Factura" type="text" class="form-control" readonly>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <label>Cliente</label>
                                        <input v-model="objCancel.Cliente" id="Cliente" name="Cliente" type="text" class="form-control" readonly>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <label>Observaciones</label>
                                        <textarea v-model="objCancel.Observaciones" name="Observaciones" id="Observaciones" cols="30" rows="4" class="form-control"></textarea>
                                        <CValidation v-if="this.errorvalidacion.Observaciones" :Mensaje="'*'+errorvalidacion.Observaciones[0]"/>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <label>Motivo Cancelación</label>
                                        <select v-model="objCancel.MotivoCancelacion" @change="VaciarSustitucion()" name="MotivoCancel" id="MotivoCancel" class="form-control form-select">
                                            <option value="0">Seleccione una opción</option>
                                            <option value="01">01 - Comprobante emitido con errores con relación</option>
                                            <option value="02">02 - Comprobante emitido con errores sin relación</option>
                                            <option value="03">03 - No se llevó a cabo la operación</option>
                                            <option value="04">04 - Operación nominativa relacionada en una factura global</option>
                                        </select>
                                        <CValidation v-if="this.errorvalidacion.MotivoCancelacion" :Mensaje="'*'+errorvalidacion.MotivoCancelacion[0]"/>
                                    </div>
                                </div>

                                <div v-if="objCancel.MotivoCancelacion == '01'" class="form-group row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <label>Folio de Sustitución</label>
                                        <input v-model="objCancel.FolioSustitucion" id="FolioSustitucion" name="FolioSustitucion" type="text" class="form-control">
                                        <CValidation v-if="this.errorvalidacion.FolioSustitucion" :Mensaje="'*'+errorvalidacion.FolioSustitucion[0]"/>
                                    </div>
                                </div>
                            </div>  

                            <div class="col-12 col-sm-12 col-md-5 col-lg-5 mb-3">
                                <div class="card" >
                                    <div class="card-header text-white bg-primary">
                                        <strong>Datos de la factrua</strong> 
                                    </div>

                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item ">
                                            <label style="font-size:16px;" for=""> Documento : </label> 
                                            <label>{{objEstatusFactura.CodigoEstatus}}</label>
                                        </li>
                                        <li class="list-group-item">
                                            <label style="font-size:16px;" for="">Es cancelable : </label> 
                                            <label>{{objEstatusFactura.EsCancelable}}</label> 
                                        </li>
                                        <li class="list-group-item">
                                            <label style="font-size:16px;" for="">Estado: </label> 
                                            <label>{{objEstatusFactura.Estado}}</label> 
                                        </li>
                                        <li class="list-group-item">
                                            <label style="font-size:16px;" for="">Estatus cancelacion: </label> 
                                            <label>{{objEstatusFactura.EstatusCancelacion}}</label>
                                        </li>
                                    </ul>
                                </div>
                            </div>  

                        </div>
                    </form>
                </div>
            </template>
        </CLoader>
    </div>
</template>

<script>

export default {
    name: 'FormCancelar',
    props: ['poBtnSave'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCancel: {
                UUID: '',
                FolioFactura: '',
                Cliente: '',
                Observaciones: '',
                MotivoCancelacion: '0',
                FolioSustitucion: '',
                IdDelCFDI: '',
                TipoCancelacion: '',
                EstatusCancel: '',
            },
            objEstatusFactura: {
                CodigoEstatus: '',
                EsCancelable: '',
                Estado: '',
                EstatusCancelacion: '',
            },
            segurity: {},
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
        }
    },
    methods: {
        async Guardar()
        {
            this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

            await this.$http.post('setStatusCancelacion/',
                this.objCancel
            ).then((res) => {
                this.EjecutaConExito(res);
            }).catch((err) => {
                this.EjecutaConError(err);
            });
        },
        EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);

            let obj = {
				message: res.data.message,
				typemsg: res.data.typemsg,
			};
			this.EjecutaMensajeAlerta(obj);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;

            // SI DEVUELVE TYPEMSG CORRESPONDE A UN ERROR DE TIMBRADO, SINO CORRESPONDE A UN ERROR DE VALIDACION NORMAL
			if(err.response.data.typemsg)
			{
				this.EjecutaMensajeAlerta(err.response.data);
			}
			else
			{
                if(err.response.data.errors){
                    this.errorvalidacion = err.response.data.errors;
                    this.poBtnSave.Toast = 2;
                }
                else{
                    this.$toast.error(err.response.data.message);
                }
            }
        },
        EjecutaMensajeAlerta(DataAlert)
		{
			console.log(DataAlert);
			let Titulo = 'Se produjo un error al cancelar';
			let Mensaje = DataAlert.message;
			let Icon = 'warning';
			let Content = '';

			switch(DataAlert.typemsg)
			{
				case 3:

					let htmls = `
					<h3>Problemas detectados:</h3><br>
					<hr>
					<div class="card scrollCfdi">
						<div class="card-body">
							<ul class="list-group">`;
					
					$.each(DataAlert.errors.Error, function(key, value){
						htmls+=`<li class="list-group-item">`+value+`</li>`;
					});

					htmls+=`</ul>
						</div>
					</div>`;
					Content = htmls;

				break;

				case 1:
					Titulo = 'Solicitud de Cancelación Procesada';
					Icon = 'success';
				break;
			}

			this.$swal(
            {
                title: '<h2 style="font-size:25px; font-weight: 700;">'+Titulo+'</h2>',
                text: Mensaje,
				html: Content,
                icon: Icon,
                confirmButtonText: 'Aceptar',
                showCloseButton: true,
                showLoaderOnConfirm: true,
                confirmButtonColor: '#00a389',
            });
		},
        Recuperar()
        {
            this.ConfigLoad.ShowLoader = true;
            let Ruta = '';

            /* switch(this.objCancel.TipoCancelacion)
            {
                case 'F':
                    Ruta = +this.objConfigEncuestaRespuesta.IdConfigEncuestaRespuesta
                break;
            } */
            this.$http.get('getStatusCancelacion',{
                params: {
                    IdDelCFDI: this.objCancel.IdDelCFDI,
                    TipoCancelacion: this.objCancel.TipoCancelacion,
                }
            }).then((res)=>{
                let respuesta = res.data.data;

                this.objCancel.UUID = respuesta.UUID;
                this.objCancel.FolioFactura = respuesta.FolioFactura;
                this.objCancel.Cliente = respuesta.Cliente;
                this.objCancel.Observaciones = respuesta.Observaciones;
                this.objCancel.MotivoCancelacion = respuesta.MotivoCancelacion;
                this.objCancel.FolioSustitucion = respuesta.FolioSustitucion;
                this.objCancel.EstatusCancel = respuesta.EsCancelable;

                this.objEstatusFactura.CodigoEstatus = respuesta.CodigoEstatus;
                this.objEstatusFactura.EsCancelable = respuesta.EsCancelable;
                this.objEstatusFactura.Estado = respuesta.Estado;
                this.objEstatusFactura.EstatusCancelacion = respuesta.EstatusCancelacion;

                if(respuesta.EstatusCancel == 'Cancelado'){
                    this.poBtnSave.ShowBtnSave = false;
                }
                else{
                    this.poBtnSave.ShowBtnSave = true;
                }
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        Limpiar()
        {
            this.objCancel = {
                UUID: '',
                FolioFactura: '',
                Cliente: '',
                Observaciones: '',
                MotivoCancelacion: '0',
                FolioSustitucion: '',
                IdDelCFDI: '',
                TipoCancelacion: '',
                EstatusCancel: '',
            };

            this.objEstatusFactura = {
                CodigoEstatus: '',
                EsCancelable: '',
                Estado: '',
                EstatusCancelacion: '',
            };
        },
        VaciarSustitucion()
        {
            if(this.objCancel.MotivoCancelacion != '01'){
                this.objCancel.FolioSustitucion = '';
            }
        }
    },
    created() {
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(obj)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });

            this.Limpiar();

            this.objCancel.TipoCancelacion = obj.TipoCancelacion;
            this.objCancel.IdDelCFDI = obj.IdDelCFDI;
            this.Recuperar();

            //this.ConfigLoad.ShowLoader = false;
        });
    },
}
</script>

<style>

</style>